import React, { useState } from "react";
import {
  Modal,
  Row,
  Button,
  Typography,
  Space,
  Card,
} from "antd";
import { IoCloseSharp } from "react-icons/io5";
import { MdDone } from "react-icons/md";

const { Title, Text } = Typography;

function SuccessModal({ isSuccessModalVisible, setIsSuccessModalVisible, kitNumber, fetchKitLists, samplerId }) {

  const closeModal =()=>{
    setIsSuccessModalVisible(false);
    fetchKitLists();
  }
  const footer = (
    <Row justify="end" style={{ marginTop: 24 }}>
      <Space size={16}>
        <Button
          type="primary"
          size="large"
          style={{
            borderRadius: 8,
            fontWeight: 700,
            background: "#23235F",
            color: "#fff",
          }}
          onClick={closeModal}
        >
          Done
        </Button>
      </Space>
    </Row>
  );
  return (
    <Modal
      visible={isSuccessModalVisible}
      onCancel={closeModal}
      footer={null}
      width={600}
      bodyStyle={{
        borderRadius: 16,
        padding: 24,
        background: "#fff",
      }}
      style={{ borderRadius: 16 }}
      closeIcon={<IoCloseSharp size="24" />}
      centered
      className="modal-content"
    >
      <Title level={3} style={{ fontWeight: 800, marginBottom: 20 }}>
        {samplerId ? "Updated Sampler" : "Assigned Sampler"}
      </Title>

      <Card
        style={{
          background: "#EAF7EA",
          borderRadius: "16px",
          textAlign: "center",
          border: "2px solid #E5E8EC",
          boxShadow:
            "0 4px 24px 0 rgba(44, 39, 56, 0.04), 0 1.5px 4px 0 rgba(44, 39, 56, 0.04)",
        }}
      >
        <MdDone size={40} color="#2E7D32" />
        <Title level={4} style={{ fontWeight: 800, marginBottom: 8 }}>
          {samplerId ? "Sampler Updated Successfully!" : "Sampler Assigned Successfully!"}
        </Title>
        <Text style={{ color: "#7f8185", fontWeight: 600, fontSize: 15 }}>
         {kitNumber}
        </Text>
        <br />
        <Text style={{ color: "#8A8FA3", fontWeight: 600, fontSize: 15 }}>
          Status: Packed
        </Text>
      </Card>
      {footer}
    </Modal>
  );
}

export default SuccessModal;
